import KidoAPIInstance from "services/KidoConfigApi";

export const getCampaignDetailApi = async params => {
	const { business, campaignId } = params;
	const path = `api/campaign/detail?business=${business}&campaignId=${campaignId}`;
	return await KidoAPIInstance.get(path);
};

export const getListCampaignApi = async (business, token, infoDevice) => {
	const path = `api/campaign/list?business=${business}`;
	return await KidoAPIInstance.get(path, token, infoDevice);
};

export const getLoyaltyDetailApi = async params => {
	const { business, loyaltyId } = params;
	const path = `api/loyalty/detail?business=${business}&loyaltyId=${loyaltyId}`;
	return await KidoAPIInstance.get(path);
};

export const getLoyaltyPointDetailApi = async (business, loyaltyId) => {
	const path = `api/loyalty/detailLoyaltyPoint?business=${business}&loyaltyId=${loyaltyId}`;
	return await KidoAPIInstance.get(path);
};

export const getMerchandisingDetailApi = async params => {
	const { business, merchandisingId } = params;
	const path = `api/merchandising/detail?business=${business}&merchandisingId=${merchandisingId}`;
	return await KidoAPIInstance.get(path);
};
